<template>
  <BaseNew @new-open-action="mainLoadServerEntry" ref="baseNew" :modelNameSingular="modelNameSingular"
    newCreateButtonLabel="Visualizar CC-e" width="80%" :formErrors="formErrors" :loading="loading"
    :pageLoading="pageLoading" :inlineAddButton="true" addButtonIcon="mdi-card-multiple" :nfe="nfe"
    :hideSaveButton=true :useModelInsteadOfButton="useModelInsteadOfButton"
    :newTitle="'Visualização de NFe'">
    <template slot="newForm">
      <v-card-text>
        <v-row>
          <v-col cols="12" class="" v-if="cces !=null">
            <CceIndex :cces="cces"/>
          </v-col>
        </v-row>

      </v-card-text>
    </template>
  </BaseNew>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseNew from "@shared_components/base_new.vue";
import CceIndex from "./index.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      printing: false,
      entry: null,
      cces: null,
      formErrors: [],
      extraData: null,
    };
  },
  props: {
    nfe: {
      type: Object,
      default: null,
    },
    useModelInsteadOfButton: {
      type: Boolean,
      default: false
    },
    modelNameSingular: {
      type: String,
      default: "Carta de Correção"
    }
  },
  components: {
    Form: Form,
    BaseNew: BaseNew,
    CceIndex: CceIndex,
  },
  methods: {
    mainLoadServerEntry: function () {
      // console.log("multiSale", this.multiSale);

      // if (this.multiSale){
      //   this.cashFlow = {id: this.multiSale.sales[0]};
      // }
      // console.log("indexxxx");
      // if (this.cashFlow) {
      this.loadServerEntry();
      // } else if (this.multiSale) {
      //   this.loadServerEntryMultiSale();
      // }
    },
    loadServerEntry: function () {
      this.error = null;
      this.loading = true;

      // var id = this.cashFlow?.id || this.multiSale?.sales[0];
      this.$apollo
        .query({
          query: LOAD_CCES,
          fetchPolicy: "no-cache",
          variables: {
            id: this.nfe.id
          }
        })
        .then(response => {
          this.cces = response.data.accountContext.nfe.cces;
          console.log("cces", this.cces);

          // this.extraData = response.data;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
  }
};

const LOAD_CCES = gql`
  query($id: ID!){
    accountContext {
      nfe(id: $id) {
        cces{
          id
          correcao
          sequencia
          status
          statusKey
          statusValue
          statusColor
        }
      }
    }
  }
`;

</script>

<style scoped></style>
